import React from 'react'

import { t } from 'i18n'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { formatDate } from 'utils'
import { add } from 'date-fns'

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: theme.palette.inputs.label.semibold,
    margin: theme.spacing(1, 0)
  },
  subtitle: {
    color: theme.palette.inputs.label.color.link,
    marginTop: theme.spacing(2.5)
  },
  description: {
    color: theme.palette.inputs.label.color.light,
    marginBottom: theme.spacing(3)
  },
  footNote: {
    fontWeight: theme.palette.inputs.label.semibold,
    color: theme.palette.inputs.label.color.regular,
    marginBottom: theme.spacing(0.5)
  }
}))

export const CredentialsFormDescription: React.FC = () => {
  const classes = useStyles()
  return (
    <div>
      <Typography component='h1' variant='h6' className={classes.subtitle}>
        {t('sign_up.credentials_form.subtitle')}
      </Typography>
      <Typography component='h1' variant='h3' className={classes.title}>
        {t('sign_up.credentials_form.title')}
      </Typography>
      <Typography component='p' className={classes.description}>
        {t('sign_up.credentials_form.description')}
      </Typography>
    </div>
  )
}

export const ConfirmationFormDescription: React.FC = () => {
  const classes = useStyles()
  return (
    <div>
      <Typography component='h1' variant='h6' className={classes.subtitle}>
        {t('sign_up.credentials_form.subtitle')}
      </Typography>
      <Typography component='h1' variant='h3' className={classes.title}>
        {t('sign_up.confirmation_form.title')}
      </Typography>
    </div>
  )
}

export const CompanyFormDescription: React.FC = () => {
  const classes = useStyles()
  return (
    <div>
      <Typography component='h1' variant='h6' className={classes.subtitle}>
        {t('sign_up.company_form.subtitle')}
      </Typography>
      <Typography component='h1' variant='h3' className={classes.title}>
        {t('sign_up.company_form.title')}
      </Typography>
      <Typography component='p' className={classes.description}>
        {t('sign_up.company_form.description')}
      </Typography>
    </div>
  )
}

export const CardFormDescription: React.FC = () => {
  const classes = useStyles()
  return (
    <div>
      <Typography component='h1' variant='h6' className={classes.subtitle}>
        {t('sign_up.card_form.subtitle')}
      </Typography>
      <Typography component='h1' variant='h3' className={classes.title}>
        {t('sign_up.card_form.title')}
      </Typography>
      <Typography component='p' className={classes.description}>
        {t('sign_up.card_form.description')}
      </Typography>
      <Typography component='p' className={classes.footNote}>
        {t('sign_up.card_form.first_payment', { date: formatDate(add(new Date(), { months: 2, days: 1 }), 'LLL d') })}
      </Typography>
      <Typography component='p' className={classes.footNote}>
        {t('sign_up.card_form.no_cancellation_fee')}
      </Typography>
    </div>
  )
}
